/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectUserResponseDto } from '../../models/core-project-user-response-dto';

export interface ProjectUsersControllerFindAll$Params {
  tenant: string;
  projectId?: string;
  userId?: string;
}

export function projectUsersControllerFindAll(http: HttpClient, rootUrl: string, params: ProjectUsersControllerFindAll$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectUserResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectUsersControllerFindAll.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('projectId', params.projectId, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectUserResponseDto>>;
    })
  );
}

projectUsersControllerFindAll.PATH = '/o2-core/project-users/{tenant}';
